<script type="text/javascript">

    export default {
        props: {
            itemsCount: { type: Number, default: null }
        },
        data: function() {
            return {
                index: 1
            }
        },
        computed: {
            isScrollLeftDisabled: function () {
                return this.index <= 1
            },
            isScrollRightDisabled: function () {
                return this.index == this.itemsCount
            },
            scrollTransform: function () {
                return 'transform: translateX(' + -(this.index - 1) * 100 + '%)';
            }
        },
        methods: {
            scrollLeft: function () {
                this.index--;
            },
            scrollRight: function () {
                this.index++;
            }
        }
    };
</script>

